module.exports = __webpack_public_path__ + "media/images/application/placeholder/40ft_container_flashoffer_16x9_600x338px-7db030ed8ed4a50d2ad858f9ec2f309d.png";